import React, { useEffect, useState } from 'react';
import i18n from '../../utils/i18n';
import { useDispatch, useSelector } from "react-redux";
import { getSessionFromStorage, hasSessionExpired, useParameters } from '../../utils/session';
import { domain } from '../../utils/config';
import { profileAction } from '../reducers/profile-slice';
import { authenticationRefresh } from '../actions/auth-actions';
import CircularLoader from '../../components/CircularLoader';
import { useGetRequests } from "../../utils/queries";

const TranslationsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { status: authStatus } = useSelector((state) => state.auth.data);
  const {requestParameters, cachedParameters} = useParameters();
  const localcode = cachedParameters?.locale || requestParameters?.locale || "";
  const getLocaleRequest = useGetRequests();
  const getOrentationRequest = useGetRequests();

  useEffect(() => {
    if (authStatus === "success" || getSessionFromStorage()) {
      if (hasSessionExpired()) {
        const session = getSessionFromStorage();
        const data = {
          value: session.refresh_token,
        };
        dispatch(authenticationRefresh(data));
      } else {
        getLocaleRequest.mutate(
          {
            url: `${domain}social-api/translations?locale=${localcode}`,
          },
          {
            mutationKey: `getTranslations${localcode}`,
            onSuccess: (success) => {
              if (success.status === 200) {
                i18n.addResourceBundle(
                  "en",
                  "translation",
                  success.data.content.translations,
                  true,
                  true
                );
              }
              setLoading(false);
            },
            onError: (error) => {
             if(error.response.status !== 401){
              setLoading(false);
             }
              console.error("Error loading translations:", error);
            },
          }
        );

        // language-orientation
        getOrentationRequest.mutate(
          {
            url: `${domain}core-api/public/languages/${localcode}`,
          },
          {
            mutationKey: `getOrientation${localcode}`,
            onSuccess: (success) => {
              if (success.status === 200) {
                dispatch(profileAction.setLanguageOrientation(
                  success.data.content.languageOrientation
                ));
              }
            },
            onError: (error) => {
              console.error("Error in getting orientation:", error);
            },
          }
        );
      }
    }
  }, [authStatus]);
 
  return <>{loading ? <CircularLoader/> : children}</>;
};
 
export default TranslationsProvider;
